export const GET_LIST_THUDELETE = "GET_LIST_THUDELETE";
export const GET_LIST_THUDELETE_SUCCESS = "GET_LIST_THUDELETE_SUCCESS";
export const GET_LIST_THUDELETE_FAILURE = "GET_LIST_THUDELETE_FAILURE";

export const UPDATE_SEARCHTDATA_THUDELETE = "UPDATE_SEARCHTDATA_THUDELETE";
